import React from "react"
import css from "./NewAccessType.scss"
import Select from "common/StyledSelect";
import PropTypes from "prop-types"
const OPTIONS = [
    {value: "general_data_extracts", label: "General Data Extracts"},
    {value: "eab_edify", label: "EAB Edify"}
];

/**
 * This displays the dropdown menu to select an access type in the new access key modal. Once the tenant
 * admin clicks 'Create', an API call is made to create a new IAM user with credentials. When the IAM user is created,
 * a DataExtractUserType tag is added with the name of the type selected from this dropdown menu.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} the dropdown menu to select an access type when creating a new access key
 */
const NewAccessType = (props) => {
    return (
        <div data-testid="access-type-modal">
            <label htmlFor="new-access-type-dropdown">
                <div className={css['description']}>
                    To create an access key, please select the purpose of access.
                </div>
            </label>
            <div className={css['input']}>
                <label>Purpose</label>
                <Select id="new-access-type-dropdown"
                        ariaLabel="new-access-type-dropdown"
                        onChange={option => props.setSelectedOption(option)}
                        options={OPTIONS}
                        value={props.selectedOption} />
            </div>
        </div>)
}

NewAccessType.propTypes = {
    selectedOption: PropTypes.object,
    setSelectedOption: PropTypes.func.isRequired,
}

export default NewAccessType
